import * as React from 'react';

import { useApplicationContext } from '../../../common/containers/ApplicationContext';
import { ESearchStringView } from '../../../common/services/microfrontends/types';

export function useSearchStringView(isExpanded: boolean): void {
  const { microfrontendsAPI, logger } = useApplicationContext();
  const appliedViewRef = React.useRef(ESearchStringView.Button);

  React.useEffect(() => {
    const view = isExpanded ? ESearchStringView.SearchString : ESearchStringView.Button;

    if (!microfrontendsAPI || appliedViewRef.current === view) {
      return;
    }

    appliedViewRef.current = view;

    microfrontendsAPI.searchString.setView(view).catch((error: Error) => {
      logger.warning(error, {
        degradation: 'Вид поисковой строки не переключён',
        domain: 'useSearchStringView',
      });
    });
  }, [isExpanded, logger, microfrontendsAPI]);
}
